import { useState, useEffect } from "react";
import { Box, Grid, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateComponent = ({
  setDate,
  setDisplayEndDate,
  SelectedStartDate,
  setSelectedStartDate,
  endDate,
  setEndDate,
  SelectedEndDate,
  setSelectedEndDate,
  startDateFormat,
  setstartDateFormat,
}) => {
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  const datePickerOnChange = (val) => {
    setSelectedStartDate(val);
    setDate(val ? val.toDate().toISOString() : "");
    setstartDateFormat(val ? val.format("YYYY-MM-DD") : "");
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (val) => {
    setSelectedEndDate(val);
    setDisplayEndDate(val ? val.toDate().toISOString() : "");
    setEndDate(val ? val.format("YYYY-MM-DD") : "");
    setEndDateOpen(false);
  };

   useEffect(() => {
    const firstDay = dayjs().startOf("month");
    const lastDay = dayjs().endOf("month");

    setSelectedStartDate(firstDay);
    setDate(firstDay.toDate().toISOString());
    setstartDateFormat(firstDay.format("YYYY-MM-DD"));

    setSelectedEndDate(lastDay);
    setDisplayEndDate(lastDay.toDate().toISOString());
    setEndDate(lastDay.format("YYYY-MM-DD"));
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          label="Date"
          size="small"
          value={
            SelectedStartDate && SelectedEndDate
              ? `${SelectedStartDate.format(
                  "DD-MM-YYYY"
                )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
              : SelectedStartDate
              ? `${SelectedStartDate.format("DD-MM-YYYY")}`
              : ""
          }
          id="datepickerfield"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <CalendarMonthIcon
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  cursor: "pointer",
                  mr: 1,
                }}
                onClick={() => setStartDateOpen(true)}
              />
            ),
            sx: {
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            },
          }}
          onClick={() => setStartDateOpen(true)}
          sx={{ width: "100%" }}
        />

        <Box sx={{ position: "relative" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={startDateOpen}
              onOpen={() => setStartDateOpen(true)}
              onClose={() => setStartDateOpen(false)}
              value={SelectedStartDate}
              onChange={datePickerOnChange}
              maxDate={SelectedEndDate || undefined}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector("#datepickerfield"),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={endDateOpen}
              onOpen={() => setEndDateOpen(true)}
              onClose={() => setEndDateOpen(false)}
              value={SelectedEndDate}
              onChange={datePickerOnChangeEnd}
              minDate={SelectedStartDate || undefined}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector("#datepickerfield"),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DateComponent;
